import angular from 'angular';
import placesListModule from '../placesListModule';

function utility($filter, urlService, resources) {
  'ngInject';

  return {
    getVotePercentage(upvotes, downvotes) {
      let percentUp = 0;
      if (!isNaN(upvotes) && !isNaN(downvotes)) {
        if (upvotes === 0) {
          if (downvotes === 0) {
            return null;
          }
          percentUp = 0;
        } else if (downvotes === 0) {
          percentUp = 100;
        } else {
          percentUp = Math.floor((upvotes / (upvotes + downvotes)) * 100);
        }

        if (percentUp > 100) {
          percentUp = 100;
        }
      }
      return `${percentUp}%`;
    },

    buildGameReferralUrl(place, sortName, position, totalCount, sortPosition, pageId) {
      const urls = urlService.getGameDetailReferralUrls();
      const urlInHomeTemplate = urls.home;
      sortPosition = sortPosition || '';
      pageId = pageId || '';
      return $filter('formatString')(urlInHomeTemplate, {
        sortName,
        placeId: place.placeId,
        position,
        totalInSort: totalCount,
        sortPosition,
        pageId
      });
    },

    buildScrollbar(className) {
      const scrollbarElm = angular.element(className);
      scrollbarElm.mCustomScrollbar({
        autoExpandScrollbar: false,
        scrollInertia: 1,
        contentTouchScroll: 1,
        mouseWheel: {
          preventDefault: true
        }
      });
    }
  };
}

placesListModule.factory('utility', utility);

export default utility;
